import { initializeAppCheck, ReCaptchaV3Provider, getToken } from 'firebase/app-check'
import { app } from './firebaseOdinInit'

let appCheck: any = null
let isAppCheckInitialized = false

export const initializeFirebaseAppCheck = () => {
  if (isAppCheckInitialized || !app) {
    return appCheck
  }

  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    })

    isAppCheckInitialized = true
    return appCheck
  } catch (error) {
    console.error('Error initializing Firebase App Check:', error)
    return null
  }
}

export const getAppCheckToken = async (): Promise<string | null> => {
  if (!appCheck) {
    console.warn('App Check not initialized')
    return null
  }

  try {
    const appCheckTokenResponse = await getToken(appCheck, false)
    return appCheckTokenResponse.token
  } catch (error) {
    console.error('Error getting App Check token:', error)
    return null
  }
}

export const shouldUseAppCheck = (url: string): boolean => {
  const protectedEndpoints = ['/api-auth/discovery']

  try {
    const urlPath = new URL(url).pathname
    return protectedEndpoints.some((endpoint) => urlPath.includes(endpoint))
  } catch (error) {
    console.error('Error parsing URL:', error)
    return false
  }
}
